export const MOVEFLEX_NUMBERS = {
	MOVEFLEX: '1',
	PLANALTO: '000000005',
	UNESUL: '000000008',
	ROTA: '000000015',
}
